import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DepositTypeProperties } from '../Models/DepositTYpeProperties';

@Injectable({
  providedIn: 'root'
})

export class DepositService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  getAllDepositTypes(): Observable<DepositTypeProperties[]> {
    return this.http.get<DepositTypeProperties[]>(this.baseUrl + '/Deposit/GetAllDepositTypes')
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  
  create(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Deposit/addNewDepositType', obj, this.httpOptions)
      .pipe(map((data: any) => {   
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  getDepositTypeById(depositTypeId): Observable<DepositTypeProperties> {
    //console.log(depositTypeId);
    return this.http.get<DepositTypeProperties>(this.baseUrl + '/Deposit/GetDepositTypeById/' + depositTypeId)
      .pipe(map((data: any) => {
       //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }
  update(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Deposit/updateDepositType', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  
 





}
